module.exports = __webpack_public_path__ + "stratumblue_web_banner_es.jpg?d1c2ffe4b8c505dba5fb5e34fc2d6f3b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/stratumblue_web_banner_es.jpg
// module id = 762
// module chunks = 2